<!-- Translated: yes -->
<template>

  <div :class="'dropdown-wrapper ' + (isOpen ? 'active' : '') + ' ' + (validated ? 'validated' : '') + ' type--' + type + ' ' + (error ? 'error' : '')">

    <label @click="toggle">

      <span class="prefix" v-if="prefixicon">
        <icon v-if="!validated" :name="prefixicon" :scale="2"></icon>
        <icon v-if="validated" :name="prefixiconValidated" :scale="2"></icon>
      </span>

      <div v-if="combo && isOpen" class="value-editor">
        <input type="number" @click.stop="stopper" v-model="search" @keyup="setValueFromTyping($event, {value: search})" />
      </div>

      <div v-if="combo && !isOpen" class="value" v-html="selectedLabel"></div>
      <div v-if="!combo && !valuebinder" class="value" v-html="selectedLabel"></div>
      <div v-if="!combo && valuebinder" class="value" v-html="selectedLabel + ' ' + valueSuffix"></div>

      <span class="suffix" @click="clickSuffix">
        <icon v-if="type === 'large' && allowEmpty" :name="validated ? 'circle-green-minus' : 'chevron-down'" :scale="validated ? 1.6 : 1"></icon>
        <icon v-if="type === 'large' && !allowEmpty" :name="'chevron-down'" :scale="1"></icon>
        <icon v-if="type === 'clean'" :name="'chevron-down'" :scale="1"></icon>
        <icon v-if="type === 'language'" :name="'chevron-down'" :scale="1"></icon>
        <icon v-if="type === 'country'" :name="'chevron-down'" :scale="1"></icon>
        <icon v-if="type === 'cleanlarge'" :name="'chevron-down'" :scale="1"></icon>
        <icon v-if="type === 'month'" :name="'chevron-down'" :scale="1.2"></icon>
        <icon v-if="type === 'mini'" name="sort-blue" :scale="1"></icon>
      </span>

    </label>

    <div ref="options" class="options" v-if="isOpen" :style="'max-height:' + this.optionHeight + 'px;'">
      <div v-for="option in filteredOptions" :class="{selected: (option.value === valuebinderComputed), option: true, 'option-row': !option.separator, separator: option.separator}" @click.stop="setValue(option)">

        <Checkbox v-if="type === 'clean'" label-position="after" label="" :value="option.value" :valuebinder.sync="tempValue" :size="16" />

        <div v-if="type === 'language'" class="flag" :style="'background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + option.flag + '.svg)'" />
        <div v-if="type === 'country'" class="flag" :style="'background-image: url(' + option.flag + ')'" />

        <b style="margin-left: 7px;" v-html="option.title"></b>

        <span>{{option.subtitle}}</span>

        <span :class="{
          price: true,
          marked: option.marked
          }" v-if="option.price1">{{option.price1 | currency}}</span>

        <Checkbox v-if="type === 'language'" label-position="after" label="" :value="option.value" :valuebinder.sync="tempValue" :size="16" />
        <Checkbox v-if="type === 'country'" label-position="after" label="" :value="option.value" :valuebinder.sync="tempValue" :size="16" />

      </div>

      <slot></slot>

    </div>

  </div>

</template>

<script>
import Checkbox from '@/components/components/Checkbox';

export default {
  components: {
    Checkbox,
  },
  props: {
    valuebinder: {},
    value: {},
    label: {},
    options: {
      default: [],
    },
    prefixicon: {},
    prefixiconValidated: {},
    type: {
      default: 'large',
    },
    allowEmpty: {
      default: true,
    },
    boldLabel: {
      default: false,
    },
    valueSuffix: {
      default: '',
    },
    onclick: {
      type: Function,
      default: () => true,
    },
    validated: {
      default: false,
    },
    combo: {
      default: false,
    },
    classList: {
      default: '',
    },
    error: {
      default: false,
    },
    showLabelSubtitle: {
      default: true,
    },
    withBackground: {
      default: false,
    },
    valueAsLabel: {
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      search: '',
      tempValue: null,
      optionHeight: 0,
    };
  },
  /* mounted() {
  }, */
  created() {
    window.addEventListener('resize', this.setOptionsHeight);
  },
  destroyed() {
    window.removeEventListener('resize', this.setOptionsHeight);
  },
  methods: {
    stopper(e) {
      this.open(e);
    },
    open(e) {
      this.isOpen = true;
      this.updateBody();
      this.setOptionsHeight();
      e.stopPropagation();
    },
    clicked(e) {
      this.$emit('clicked', e);
    },
    toggle(e) {
      this.isOpen = !this.isOpen;
      this.updateBody();
      this.clicked(e);
      this.setOptionsHeight();
      e.stopPropagation();
    },
    clickSuffix(e) {
      if (this.allowEmpty) {
        if (this.validated) {
          this.$emit('clicked-suffix', e);
          e.stopPropagation();
          this.$nextTick(() => {
            if (this.valuebinder) {
              this.setValue({});
            }
          });
        } else {
          this.toggle(e);
        }
      } else {
        this.toggle(e);
      }
    },
    close() {
      this.isOpen = false;
      this.$emit('closed');
      this.updateBody();
    },
    setValue(option, skipEmit) {
      this.tempValue = option.value;
      this.search = option.value;

      if (typeof skipEmit === 'undefined' || !skipEmit) {
        this.$emit('update:valuebinder', option.value);
        this.$emit('changed', option);
        this.$emit('input', option.value);
        this.$emit('touch');
        this.close();
      }
    },
    setValueFromTyping($event, option) {
      this.tempValue = option.value;
      this.$emit('update:valuebinder', option.value);
      this.$emit('changed', option.value);
      this.$emit('input', option.value);
      this.$emit('touch');

      if ($event.keyCode === 13) {
        this.close();
      }
    },
    updateBody() {
      if (this.isOpen) {
        document.body.classList.add('dropdown-opened');
        if (this.withBackground) {
          document.body.classList.add('dropdown-opened--with-background');
        }
        document.addEventListener('click', this.documentClick);
      } else {
        document.body.classList.remove('dropdown-opened');
        document.body.classList.remove('dropdown-opened--with-background');
        document.removeEventListener('click', this.documentClick);
      }
    },
    setOptionsHeight() {
      this.$nextTick(() => {
        const $el = this.$refs.options;
        if ($el) {
          const top = $el.getBoundingClientRect().top;
          const height = window.innerHeight;
          this.optionHeight = height - top - 10;
        }
      });
    },
    documentClick(e) {
      if (e.target !== this.$el && !this.$el.contains(e.target)) {
        e.stopPropagation();
        this.close();
      }
    },
  },
  mounted() {
    if (this.value) {
      this.valuebinder = this.value;
    }
    this.tempValue = this.valuebinder;
  },
  computed: {
    valuebinderComputed() {
      return this.tempValue;
    },
    selectedLabel() {
      const $this = this;

      if (this.type === 'language') {
        return `${this.label}`;
      }

      if (this.type === 'country') {
        return `${this.label}`;
      }

      const selected = (this.options || [])
        .filter(option => $this.valuebinderComputed === option.value);
      if (selected.length) {
        const title = selected[0].title;
        if (selected[0].subtitle && this.showLabelSubtitle) {
          return `<b>${title}</b> <span class="thin">${selected[0].subtitle}</span>`;
        }
        return `${title}`;
      }

      if (this.combo && this.valuebinder) {
        return `<b>${this.valuebinder}</b>`;
      }

      if (this.valueAsLabel && this.valuebinder) {
        return `<b>${this.valuebinder}</b>`;
      }

      if (this.boldLabel) {
        return `${this.label}`;
      }

      return this.label;
    },
    filteredOptions() {
      const $this = this;
      const reg = new RegExp($this.search, 'i');

      if (!this.combo) {
        return this.options || [];
      }

      if (this.validated) {
        return this.options || [];
      }

      const options = (this.options || []).filter(option => (
        option.value.toString().match(reg)
        ||
        option.title.toString().match(reg)
      ));

      if ((!options || !options.length) && this.search) {
        return this.options;
      }

      return options;
    },
  },
};
</script>

<style lang="stylus">
body.dropdown-opened {
  overflow: hidden;
}

.type--language,
.type--country
  .flag
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 11px
    width: 18px
    margin-right: 10px
    display: inline-block;
    vertical-align: bottom
</style>
<style lang="stylus" scoped>
@import '~@/global.styl'

active-option = #DDEAEF
active-option-font = #07547E

input
  input()
  border 0
  min-width 10px
  max-width 100%
  background transparent
  &:focus
    outline-width 0

.validated
  input
    color white

affix()
  width 41px
  height 41px
  display flex
  align-items center
  justify-content center

.dropdown-wrapper
  .value
    white-space: nowrap;
    overflow: hidden;

  max-width 400px
  width 100%
  position relative
  cursor pointer
  &.active
    z-index 11

  -webkit-touch-callout none
  -webkit-user-select none
  -khtml-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none

  label
    border-radius 3px
    background-color white
    border solid 2px #bfd9e1
    font-size 12px
    //font-weight bold
    letter-spacing 0.3px
    text-align left
    color #595959
    line-height 1.6em
    cursor inherit
    font-weight normal
    display flex
    overflow hidden
    align-items center
    transition-ease()
    uppercase()
    .prefix
      affix()
      background deep-sea-blue
      color white
      border-right 1px solid white
      .icon
        margin-top -2px
        opacity: 0.8;
    .suffix
      affix()
      transition-ease()
      background pale-sky
      border-left solid 2px #bfd9e1
      .icon
        margin-top 0px
    .value,
    .value-editor
      flex auto
    .value
      padding 7px 10px 3px
      text-transform: initial
      letter-spacing: 0px
      font-size: 16px
      // color: #a2a2a2;
      +max-mobile()
        font-size: 13px
      b
        font-weight 600

  &.validated
    label
      background-color: #5aa478;
      border-color: #c7dcb7;
      color white
      font-weight bold
      font-size 12px
      .value
        font-size: 11px
        text-transform: uppercase
        font-weight: bold
        color #fff
      .prefix
        background-color #5aa478
        border-right: 2px solid #c7dcb7;
      .suffix
        background-color: #e7f1df
        border-left: solid 2px #c7dcb7;

  &.active
    label
      //background-color #005580
      //color white
      border-bottom-left-radius 0
      border-bottom-right-radius 0
    .options
      border-radius 4px
      background-color white
      border solid 1px #bfd9e1
      border-top-left-radius 0
      border-top-right-radius 0
      height auto
      //min-height 350px
      overflow-y auto
      // max-height 180px
      position absolute
      top 43px
      left 0
      width 100%
      z-index 3
      & > .option
        font-size 13px
        font-weight 300
        letter-spacing 0.4px
        text-align left
        color #262626
        padding 7px 10px
        font-size 11px
        line-height: 1.6em;
        &:nth-child(even)
          background-color #f9f9f9
        &.separator
          cursor default
          padding: 0
          padding: 3px 3px 3px 3px
          margin-top 5px
          background-color #bfd9e1
          &:first-child
            margin-top 0
          b
            font-weight normal
          disabled-normal()
          .radio-wrapper
            display none
        &.option-row:hover
          background-color active-option
          color active-option-font
        .price
          float right
          &.marked
            font-size: 9px;
            font-weight: bold;
            display: inline-block;
            background-color: #d68605;
            padding 5px 7px
            color white
            line-height: 1em
            border-radius: 3px;
      & > .selected
        font-weight bold
        background-color active-option !important
        color active-option-font !important

.error
  label
    border-color warning

.dropdown-wrapper
  &.type--mini
    background-color transparent
    max-width 75px
    label
      background-color: #ecf5f8;
      border: solid 1px #bfd9e1;
      font-size: 11px;
      font-weight: bold;
      letter-spacing: 0.3px;
      color: #005580;
      height: 30px;
      .suffix
        border 0
        background-color transparent
        width 20px
        position: relative;
        top: 4px;
        right: 2px;

.dropdown-wrapper
  &.type--clean,
  &.type--language,
  &.type--country
    background-color transparent
    label
      background-color: white;
      border: solid 1px #bfd9e1;
      font-size: 10px;
      font-weight: bold;
      letter-spacing: 0.3px;
      color: #005580;
      height: 32px;
      .suffix
        border 0
        background-color transparent
        width 20px
        position: relative;
        top: 4px;
        right: 2px;
      .value
        color inherit
        text-transform: uppercase;
        font-size: 10px
        padding 9px 16px
        line-height: 1
    .options
      top 31px
      text-transform: uppercase;
      .option
        font-size: 10px !important
        display: flex
        justify-content: space-between;
        & > .flag
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          height: 15px
          width: 23px
          margin-right: 10px
        & > b
          flex-grow: 1
        & > .radio-wrapper
          width: 15px
          margin-right: 0

    .suffix
      height 31px
      top 0 !important
      right 0 !important

.dropdown-wrapper
  &.type--cleanlarge
    width 100%
    max-width: 100%
    label
      border: solid 2px #bfd9e1;
      font-size 15px
      // line-height: 2em
      font-weight: 300
      .value
        font-size inherit
        // line-height: inherit
        padding-top 0
        padding-bottom 0
        font-weight: inherit
        color: #595959;
        text-transform: none
        height auto

.dropdown-wrapper
  &.validated.type--cleanlarge
    label
      background-color white
      .suffix
        background: #ecf5f8;
        border-left: solid 2px #bfd9e1;

.radio-wrapper
  margin-right 10px

.dropdown-wrapper.type--month
  label
    border-width 1px

    .value
      text-align center
      font-family: United Serif Cond;
      font-weight: 900;
      letter-spacing: .02em;
      font-size: 22px;
      text-transform: uppercase;
      color #504f4f
      padding-left 15px
      padding-right 0

    .suffix
      background-color: white;
      border-color: white;

  .options
    text-transform: uppercase;
    .option
      font-size: 10px
      font-family "Interstate"
</style>



// WEBPACK FOOTER //
// Dropdown.vue?20439408